import gql from 'graphql-tag';

export const submitSignup = gql`
	mutation submitSignup($input: RegisterInput!) {
		Register(input: $input) {
			error
			message
		}
	}
`;



// WEBPACK FOOTER //
// ./src/views/Register/RegisterMutations.js